module.exports = __webpack_public_path__ + "img/symbol_8.2828ad84.png";